import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useMap }  from '../../context/MapContext';
import { useAuth } from '../../context/AuthContext';
import LoginModal  from '../Modals/LoginModal';
import './SiteHeader.css';

const NAV_LINKS = [
  { label: 'Tutorial',     page: 'tutorial'      },
  { label: 'Sobre',        page: 'sobre'         },
  { label: 'Fale Conosco', page: 'fale-conosco'  },
];

const ROLE_LABELS = {
  moderador:        'Moderador',
  visualizador_interno: 'Visualizador Interno',
  gestor_municipal: 'Gestor Municipal',
  prestadora:       'Prestadora',
  sociedade:        'Sociedade',
};

const ROLE_COLORS = {
  moderador:        '#c0392b',
  visualizador_interno: '#6f42c1',
  gestor_municipal: '#2980b9',
  prestadora:       '#27ae60',
  sociedade:        '#7f8c8d',
};

function SunIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="5" />
      <line x1="12" y1="1"  x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" />
      <line x1="4.22" y1="4.22"  x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
      <line x1="1"  y1="12" x2="3"  y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );
}

function SiteHeader({ onAdminOpen, onNavigate, currentPage }) {
  const [menuOpen,  setMenuOpen]  = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);

  const { theme, toggleTheme }    = useMap();
  const { user, logout, loading } = useAuth();
  const isDark = theme === 'dark';

  return (
    <header className="site-header">
      <div className="site-header__inner">

        {/* Logo */}
        <a href="/" className="site-header__logo-link" aria-label="Projeto Saneamento Vivo — página inicial" onClick={(e) => { e.preventDefault(); onNavigate('home'); }}>
          <img
            src="/Logo_2.png"
            alt="Projeto Saneamento Vivo"
            className="site-header__logo"
            width={210}
            height={105}
          />
        </a>

        {/* Desktop nav */}
        <nav className="site-header__nav" aria-label="Navegação principal">
          {NAV_LINKS.map(({ label, page }) => (
            <button
              key={page}
              className={`site-header__nav-link${currentPage === page ? ' site-header__nav-link--active' : ''}`}
              onClick={() => onNavigate(page)}
              aria-current={currentPage === page ? 'page' : undefined}
            >
              {label}
            </button>
          ))}
        </nav>

        {/* Actions */}
        <div className="site-header__actions">

          {/* Área de autenticação */}
          {!loading && (
            user ? (
              <div className="header-user">
                {user.role === 'moderador' && (
                  <button
                    className="header-admin-btn"
                    onClick={onAdminOpen}
                    title="Painel Administrativo"
                  >
                    Admin
                  </button>
                )}
                <span
                  className="header-role-badge"
                  style={{ background: ROLE_COLORS[user.role] || '#555' }}
                >
                  {ROLE_LABELS[user.role] || user.role}
                </span>
                <span className="header-user-name" title={user.email}>{user.name}</span>
                <button
                  className="header-logout-btn"
                  onClick={logout}
                  title="Sair do sistema"
                  aria-label="Sair"
                >
                  Sair
                </button>
              </div>
            ) : (
              <button
                className="header-login-btn"
                onClick={() => setLoginOpen(true)}
                aria-label="Entrar no sistema"
              >
                Entrar
              </button>
            )
          )}

          {/* Botão de tema */}
          <button
            className="theme-btn"
            onClick={toggleTheme}
            aria-label={isDark ? 'Ativar tema claro' : 'Ativar tema escuro'}
            title={isDark ? 'Tema claro' : 'Tema escuro'}
          >
            <span className={`theme-btn__icon${isDark ? ' theme-btn__icon--spin' : ''}`} key={String(isDark)}>
              {isDark ? <SunIcon /> : <MoonIcon />}
            </span>
          </button>

          {/* Hamburger mobile */}
          <button
            className={`site-header__burger${menuOpen ? ' site-header__burger--open' : ''}`}
            onClick={() => setMenuOpen(v => !v)}
            aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
            aria-expanded={menuOpen}
          >
            <span /><span /><span />
          </button>
        </div>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <nav className="site-header__mobile-nav" aria-label="Navegação mobile">
          {NAV_LINKS.map(({ label, page }) => (
            <button
              key={page}
              className={`site-header__mobile-link${currentPage === page ? ' site-header__mobile-link--active' : ''}`}
              style={{ background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer', width: '100%' }}
              onClick={() => { onNavigate(page); setMenuOpen(false); }}
              aria-current={currentPage === page ? 'page' : undefined}
            >
              {label}
            </button>
          ))}
          {/* Entrar/Sair no menu mobile */}
          {!loading && (
            user ? (
              <button
                className="site-header__mobile-link"
                style={{ background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer', color: '#f87171' }}
                onClick={() => { logout(); setMenuOpen(false); }}
              >
                Sair ({user.name})
              </button>
            ) : (
              <button
                className="site-header__mobile-link"
                style={{ background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer' }}
                onClick={() => { setLoginOpen(true); setMenuOpen(false); }}
              >
                Entrar
              </button>
            )
          )}
        </nav>
      )}

      {/* LoginModal via Portal (evita z-index do header) */}
      {loginOpen && ReactDOM.createPortal(
        <LoginModal onClose={() => setLoginOpen(false)} />,
        document.body
      )}
    </header>
  );
}

export default SiteHeader;
